<script lang="ts">
	//UI
	import NoticeList from "@hitit/mbr/src/v7/views/NoticeList.svelte";
	import Notice from "@hitit/mbr/src/v7/views/Notice.svelte";
	import EditNotice from "../views/EditNotice.svelte";
	//Utils
	import { Router, Route } from "svelte-routing";
	//Types
	//Props
	//Constants
	//Variables
	//Functions
	//Do

</script>

<Router>
	<Route path="/">
		<NoticeList />
	</Route>
	<Route path="/read/:id" let:params>
		<Notice noticeId={params.id || ''} />
	</Route>
	<Route path="/edit">
		<!-- New Notice -->
		<EditNotice />
	</Route>
	<Route path="/edit/:id" let:params>
		<EditNotice noticeId={params.id} />
	</Route>
</Router>

<style lang="scss">
</style>
